import type { DocumentContext } from '../domain/DocumentContext';

/**
 * STRUCTURE-SAFE EMPTY DEFAULTS (LLAMS-610 Part 5).
 *
 * A real document — a quote — merges the host preview context over THIS, never over
 * `getMockDocumentContext()`. Renderers still never read an undefined nested field (every
 * required bag is present), but nothing is invented: no sample customer name, no sample line
 * items, no sample totals. An unfilled field falls to an empty string / zero / empty array, and
 * each block's own empty state takes over. `getMockDocumentContext()` stays the default for the
 * template editor's sample preview, where there is no real record to show.
 */
export function getEmptyDocumentContext(): DocumentContext {
  const today = new Date().toISOString().slice(0, 10);

  return {
    today,
    quote: {
      number: '',
      title: '',
      date: '',
      valid_until: '',
      valid_days: 0,
      status: '',
      po_number: '',
      description: ''
    },
    customer: { name: '', address: '', city: '', state: '', industry: '', tags: [] },
    contact: { name: '', email: '', phone: '', title: '' },
    user: { name: '', email: '', phone: '' },
    opportunity: { name: '', stage: '' },
    scope: { job_site_count: 0, phase_count: 0, line_item_count: 0 },
    totals: { subtotal: 0, discount_amount: 0, surcharge_amount: 0, tax_amount: 0, grand_total: 0 },
    date: { today },
    lineItems: [],
    priceBook: []
  };
}
